import { Injectable } from "@angular/core";
import { fromEvent } from "rxjs";
import { Router, NavigationEnd } from "@angular/router";
import { Utility } from "./utility";
import { animateDebounce } from "./animateDebounce";

@Injectable({
    providedIn: "root"
})
export class WindowScrollService {


    private placeHolder: Array<any> = [];
    private currentPos = 0;
    constructor(private router: Router,
        private _utility: Utility
    ) {

        // console.log("service loaded",window)
        let devicePixelRatio = 1;
        if (!this._utility.isMac()) {
            devicePixelRatio = this._utility.getWindow().innerWidth < 1366 ? (1366 / this._utility.getWindow().innerWidth) : this._utility.getWindow().innerWidth > 2560 ? (1920 / this._utility.getWindow().innerWidth) : 1; // innerWidth如果小于1366启用，使用最小尺寸;大于2560启用，使用最大尺寸
        }
        this.currentPos = Math.floor(this._utility.getWindow().scrollY * devicePixelRatio);
        let callback = animateDebounce(()=>{
            
            let posY = Math.floor(this._utility.getWindow().scrollY * devicePixelRatio);
            let screenHeight = Math.floor(this._utility.getWindow().innerHeight * devicePixelRatio);
            if (posY - this.currentPos > 0) //move down
            {
                var offsetY = posY - this.currentPos;
                for (var i = this.placeHolder.length - 1; i > -1; --i) ///执行顺序，从下往上
                {
                    if (this.placeHolder[i].relativeY - offsetY < screenHeight) ///向下移动到视角范围
                    {
                        this.placeHolder[i].action();
                        this.placeHolder.splice(i, 1);
                    }
                }

            }


        });
        fromEvent(this._utility.getWindow(), "scroll", { passive: true }).subscribe(p => callback());
        this.router.events.subscribe(evt => {
            if (evt instanceof NavigationEnd) {
                // this.currentPos = window.scrollY;
                this.currentPos = 0; // 翻页后重置为0
            }
        })
    }
  

    addPlaceHolder(relativeY, action: Function) {
        var index = this.placeHolder.length + 1;
        this.placeHolder.push({
            relativeY: relativeY,
            action: action,
            id: index
        });
        return index;
        // this.placeHolder[relativeY].push(action);
    }

    removeIndex(index) {
        if (index > -1) {
            var myIndex = this.placeHolder.findIndex(p => p.id == index);
            if (myIndex > -1) {
                this.placeHolder.splice(myIndex, 1);
            }
        }

    }

}